import { Grid } from "@mui/material";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { useMountDate } from "../../../utils/hooks/use-mount-date";
import { fromISO8601, fromISO8601_DATE, toISO8601_DATE } from "../../../utils/iso8601";
import { TimeZoneSelector } from "./time-zone-selector";

import type { ISO8601, ISO8601_DATE } from "../../../utils/iso8601";
import type { FC } from "react";

interface SpecificDateTimeSelectProps {
  date: {
    value: ISO8601_DATE | null;
    onChange: (val: string | null) => void;
    error?: string;
  };
  time: {
    value: string | null;
    onChange: (val: string | null) => void;
    error?: string;
  };
  timezone: {
    value: string | null;
    onChange: (val: string | null) => void;
    error?: string;
  };
  disabled: boolean;
}

export const SpecificDateTimeSelect: FC<SpecificDateTimeSelectProps> = ({
  date,
  time,
  timezone,
  disabled,
}) => {
  const today = useMountDate();
  return (
    <Grid container direction="row" spacing={2} sx={{ alignItems: "flex-start" }}>
      <Grid size={{ md: 12, lg: 2 }}>
        <DatePicker
          label="Date"
          minDate={today}
          value={date.value ? fromISO8601_DATE(date.value) : null}
          onChange={(newValue) => date.onChange(toISO8601_DATE(newValue))}
          sx={{ width: "100%" }}
          slotProps={{
            textField: {
              size: "small",
              helperText: date.error ?? undefined,
              error: Boolean(date.error),
            },
          }}
          disabled={disabled}
        />
      </Grid>
      <Grid size={{ md: 12, lg: 2 }}>
        <TimePicker
          label="At"
          // oxlint-disable-next-line typescript/no-unsafe-type-assertion
          value={time.value ? fromISO8601(`1970-01-01T${time.value}` as ISO8601) : null}
          onChange={(newTime) => {
            time.onChange(
              newTime
                ? `${newTime.getHours().toString().padStart(2, "0")}:${newTime.getMinutes().toString().padStart(2, "0")}`
                : null,
            );
          }}
          sx={{ width: "100%" }}
          slotProps={{
            textField: {
              size: "small",
              helperText: time.error ?? undefined,
              error: Boolean(time.error),
            },
          }}
          disabled={disabled}
        />
      </Grid>
      <Grid size={{ md: 12, lg: 8 }}>
        <TimeZoneSelector
          value={timezone.value}
          onChangeTimeZone={(tz) => timezone.onChange(tz)}
          targetChannel={false}
          disabled={disabled}
          sx={{ width: "100%" }}
          size="small"
          error={Boolean(timezone.error)}
          helperText={timezone.error}
        />
      </Grid>
    </Grid>
  );
};
